import { Skeleton } from 'newcomponents/UI/Skeleton';

export const EmptyFavoritesSkeleton = () => {
  return <Skeleton.Button style={{ width: '100%', height: 285 }} />;
};
